import { ScrollArea, Sx } from '@mantine/core';
import { type JSX, useMemo } from 'react';
import { NavLinkWithoutChildren } from './NavLinkWithoutChildren.tsx';
import { NavLinkWithChildren } from './NavLinkWithChildren.tsx';

export interface MenuItemWithChildren {
    label: string;
    icon: JSX.Element;
    sx?: Sx;
    children?: MenuItemWithoutChildren[];
}

export interface MenuItemWithoutChildren {
    label: string;
    icon: JSX.Element | string;
    url?: string;
    legacyUrl?: string;
    newTab?: string;
    handler?: () => void;
    sx?: Sx;
    windowLocation?: boolean;
}
export type MenuItem = MenuItemWithChildren | MenuItemWithoutChildren;

interface MenuProps {
    collapsed?: boolean;
    onCollapse?: () => void;
    onExtend?: () => void;
    menuItems: MenuItem[];
}

export function Menu(props: MenuProps) {
    const menuItems = useMemo(() => {
        return [
            props.collapsed
                ? {
                      label: 'MOSTRAR',
                      icon: 'arrow-circle-right',
                      handler: props.onExtend,
                      sx: () => ({
                          '@media (max-width: 62em)': {
                              display: 'none',
                          },
                      }),
                  }
                : {
                      label: 'OCULTAR',
                      icon: 'arrow-circle-left',
                      handler: props.onCollapse,
                      sx: () => ({
                          '@media (max-width: 62em)': {
                              display: 'none',
                          },
                      }),
                  },
            ...(props.menuItems ?? []),
        ];
    }, [props.collapsed, props.menuItems, props.onExtend, props.onCollapse]);

    // if (props.showCollapseItem !== false) {

    return (
        <ScrollArea type={'hover'}>
            {(menuItems ?? []).map((menuItem) => {
                const hasChildren =
                    'children' in menuItem &&
                    Array.isArray(menuItem.children) &&
                    menuItem.children?.length > 0;

                if (hasChildren) {
                    return (
                        <NavLinkWithChildren
                            key={menuItem.label}
                            menuItem={menuItem}
                            collapsed={props.collapsed}
                        />
                    );
                }
                return (
                    <NavLinkWithoutChildren
                        key={menuItem.label}
                        menuItem={menuItem}
                        collapsed={props.collapsed}
                    />
                );
            })}
        </ScrollArea>
    );
}
